import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { http } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminClaims() {
  const [claims, setClaims] = useState([]);
  const load = () => http.get("/admin/claims").then((r) => setClaims(r.data.claims || []));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      const { data } = await http.post(`/admin/claims/${id}/${action}`);
      toast.success(action === "approve" ? `Approved${data.magic_link_dev_hint ? " (dev link logged)" : ""}` : "Rejected");
      if (data.magic_link_dev_hint) {
        console.log("[DEV] Magic link:", data.magic_link_dev_hint);
        window.prompt("Dev magic-link (Resend not configured) — copy to test:", data.magic_link_dev_hint);
      }
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <AdminLayout>
      <div className="bp-container py-8">
        <h1 className="font-serif text-4xl mb-6">Brand claims</h1>
        <div className="bg-white border" style={{ borderColor: "var(--bp-border)" }}>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-left" style={{ borderColor: "var(--bp-border)" }}>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Submitted</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Brand</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Requester</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Role</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Domain match</th>
                <th className="px-4 py-3 uppercase text-xs tracking-widest">Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {claims.map((c) => (
                <tr key={c.id} className="border-b" style={{ borderColor: "var(--bp-border)" }} data-testid={`claim-row-${c.id}`}>
                  <td className="px-4 py-3 font-mono text-xs">{(c.submitted_at || "").slice(0, 10)}</td>
                  <td className="px-4 py-3 font-mono">{c.brand_slug}</td>
                  <td className="px-4 py-3">
                    <div>{c.full_name}</div>
                    <div className="text-xs font-mono" style={{ color: "var(--bp-text-muted)" }}>{c.work_email}</div>
                  </td>
                  <td className="px-4 py-3 text-xs">{c.role_at_brand}</td>
                  <td className="px-4 py-3 font-mono text-xs">
                    {c.matches_brand_domain ? <span className="bp-chip bp-chip--found">match</span> : <span className="bp-chip bp-chip--partial">check</span>}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs">{c.status}</td>
                  <td className="px-4 py-3 text-right space-x-2">
                    {c.status === "PENDING" && (
                      <>
                        <Button size="sm" variant="outline" onClick={() => act(c.id, "approve")} className="rounded-none" data-testid={`claim-approve-${c.id}`}>Approve</Button>
                        <Button size="sm" variant="outline" onClick={() => act(c.id, "reject")} className="rounded-none" data-testid={`claim-reject-${c.id}`}>Reject</Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {claims.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center" style={{ color: "var(--bp-text-muted)" }}>No claims yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
